import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { InputDataValidation } from '../_models/CaseDetails';

@Injectable()
export class CheckObjectValuesService {
  private backToMyGaps = new Subject<string>();
  private redirectToMenu = new Subject<string>();
  private enableNextPage = new Subject<string>();
  private valueHeaderNavigation = new Subject<string>();
  private titleCaseGapName = new Subject<string>();
  private redirectionDoneThroughLeftMenu = new Subject<string>();
  private discoveryValuesUpdated = new Subject<any>();
  private processStatusUpdatedData = new Subject<any>();
  private updateHeaderData = new Subject<any>();
  private sourceOfGapSelection: string;
  private sourceOfEditCase: any = {
    'fromPage': '',
    'caseId': 0,
    'caseStatus': ''
  };

  backToMyGaps$ = this.backToMyGaps.asObservable();
  redirectToMenu$ = this.redirectToMenu.asObservable();
  enableNextPage$ = this.enableNextPage.asObservable();
  valueHeaderNavigationClicked$ = this.valueHeaderNavigation.asObservable();
  titleCaseGapName$ = this.titleCaseGapName.asObservable();
  redirectionDoneThroughLeftMenu$ = this.redirectionDoneThroughLeftMenu.asObservable();
  discoveryValuesUpdated$ = this.discoveryValuesUpdated.asObservable();
  processStatusUpdatedData$ = this.processStatusUpdatedData.asObservable();
  updateHeaderData$ = this.updateHeaderData.asObservable();
  constructor(private route: Router) {

  }
  backToMyGapsClick() {
    this.backToMyGaps.next();
  }

  redirectToMenuClick(eventData) {
    this.redirectToMenu.next(eventData.toString());
  }

  enableNextPageEvt(eventData) {
    this.enableNextPage.next(eventData.toString());
  }

  navigationWithValueHeader(eventData) {
    this.valueHeaderNavigation.next(eventData.toString());
  }
  fetchCaseGapName(caseGapName: string) {
    this.titleCaseGapName.next(caseGapName.toString());
  }

  compareObjects(x: any, y: any): boolean {
    if (x === y) {
      return true;
    }
    // if both x and y are null or undefined and exactly the same

    if (!(x instanceof Object) || !(y instanceof Object)) {
      return false;
    }
    // if they are not strictly equal, they both need to be Objects

    for (const p in x) {
      if (!x.hasOwnProperty(p)) {
        continue;
      }
      // other properties were tested using x.constructor === y.constructor

      if (!y.hasOwnProperty(p)) {
        return false;
      }
      // allows to compare x[ p ] and y[ p ] when set to undefined

      if (x[p] === y[p]) {
        continue;
      }
      // if they have the same strict value or identity then they are equal

      if (typeof (x[p]) !== 'object') {
        return false;
      }
      // Numbers, Strings, Functions, Booleans must be strictly equal

      if (!this.compareObjects(x[p], y[p])) {
        return false;
      }
      // Objects and Arrays must be tested recursively
    }

    for (const q in y) {
      if (y.hasOwnProperty(q) && !x.hasOwnProperty(q)) {
        return false;
      }
      // allows x[ p ] to be set to undefined
    }
    return true;
  }

  testDataForChanges(originalData: any, changedData: any): boolean {
    if (JSON.stringify(changedData) === JSON.stringify(originalData)) {
      return true;
    } else {
      return false;
    }
  }

  redirectThroughLeftMenu() {
    this.redirectionDoneThroughLeftMenu.next();
  }

  updateSourceOfGapSelection(sourceOfGapSelection: string) {
    this.sourceOfGapSelection = sourceOfGapSelection;
  }

  getSourceOfGapSelection(): string {
    return this.sourceOfGapSelection;
  }

  updateSourceOfEditCase(sourceOfEditCase: any) {
    this.sourceOfEditCase = sourceOfEditCase;
  }

  getSourceOfEditCase(caseId: any): any {
    if (this.sourceOfEditCase && this.sourceOfEditCase.caseId && this.sourceOfEditCase.caseId.toString() === caseId) {
      return this.sourceOfEditCase;
    } else {
      return null;
    }
  }

  // tslint:disable-next-line: max-line-length
  validateInputs(name, value, isMandatory, inputDataValidations: InputDataValidation[], validateInvlidInputsOnly?: boolean, isDisabled?: boolean): boolean {
    let isValid = true;
    const min = inputDataValidations.filter(item => item.name === name)[0].min;
    const max = inputDataValidations.filter(item => item.name === name)[0].max;
    if (isDisabled) {
      return true;
    }
    // mark as complete should be disabled if mandatory field is empty but save progress will be enabled here
    if (!validateInvlidInputsOnly && isMandatory && (!value || value === '')) {
      return false;
    }
    // to check for 00000 values
    if (value && value !== '' && (value.toString() === '0' || (name !== 'String' && name !== 'Dropdown' && parseFloat(value) === 0))) {
      return false;
    }


    if (value && value !== '') {
      switch (name) {
        case 'Days':
          isValid = this.validateNumbeWithTwoDecimalPlaces(value, min, max);
          break;
        case 'Percentage':
          isValid = this.validateNumbeWithTwoDecimalPlaces(value, min, max);
          break;
        case 'Temperature':
          isValid = this.validateNumbeWithTwoDecimalPlaces(value, min, max);
          break;
        case 'Integer':
          isValid = this.validateNumber(value);
          break;
        case 'Real':
          isValid = this.validateReal(value);
          break;
        case 'String':
          isValid = this.validateString(value, isMandatory);
          break;
        case 'Dropdown':
          isValid = this.validateDropDown(value, isMandatory, validateInvlidInputsOnly);
          break;
        default:
          break;
      }
    }
    return isValid;
  }

  validateNumber(value: string): boolean {
    const regexp = new RegExp(/^[0-9]*$/gim);
    return regexp.test(value);
  }

  validateReal(value: string): boolean {
    let isValid: boolean;
    const regexp = new RegExp(/^(?:\d*\.\d{1,2}|\d+)$/);
    if (regexp.test(value)) {
      isValid = true;
    } else {
      isValid = false;
    }
    return isValid;
  }

  validateNumbeWithTwoDecimalPlaces(value, min, max): boolean {
    let isValid: boolean;
    const regexp = new RegExp(/^(?:\d*\.\d{1,2}|\d+)$/);
    if (regexp.test(value) && Number(value) >= min && Number(value) <= max) {
      isValid = true;
    } else {
      isValid = false;
    }
    return isValid;
  }

  validateString(value, isMandatory) {
    let isValid: boolean;
    if (!value || value === '') {
      isValid = false;
    } else {
      isValid = true;
    }
    return isValid;
  }

  validateDropDown(value, isMandatory, validateInvlidInputsOnly?: boolean) {
    let isValid: boolean;
    if (validateInvlidInputsOnly && value === '-1') {
      return true;
    }
    if (isMandatory && value === '-1') {
      isValid = false;
    } else {
      isValid = true;
    }
    return isValid;
  }

  discoveryValuesUpdatedNotification() {
    this.discoveryValuesUpdated.next();
  }
  processStatusUpdatedDataNotification(processStatusData) {
    this.processStatusUpdatedData.next(processStatusData);
  }
  updateHeader() {
    this.updateHeaderData.next();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/value-tracker/_services/check-object-values.service.ts